import { useCallback, useContext, useMemo } from 'react';

import { useRouter } from 'next/router';

import { careerTypes } from 'types';

import { ContentContext } from 'context/ContentContext';

import { HeroSection } from 'ui/molecules/HeroSection/HeroSection';

import { CareerCategory } from 'features/about/organisms/CareerCategory/CareerCategory';
import { Topics } from 'features/articles/atoms/Topics/Topics';
import { Benefits } from 'features/about/organisms/Benefits/Benefits';

import styles from './CareersPage.module.scss';

const benefits = [
  { text: 'Comprehensive health plans', icon: 'benefit-8' },
  { text: 'Learning and development', icon: 'benefit-9' },
  { text: 'Paid Vacation', icon: 'benefit-11' },
  { text: 'Healthy food and snacks', icon: 'benefit-10' },
];

const CareersPage = () => {
  const { additionals, pageVars } = useContext(ContentContext);
  const commonPageVars = useMemo(() => pageVars.common || {}, [pageVars.common]);

  const {
    query: { type },
  } = useRouter();

  const getFilteredCareers = useCallback(
    (category: string) =>
      additionals?.careers?.data
        .filter((career) => career.category === category)
        .map((career) => ({
          id: career.id,
          name: career.name,
          category: career.category,
          location: career.location,
          slug: career.slug,
        })) || [],
    [additionals],
  );
  const careerCategories = useMemo(
    () => careerTypes.filter((type) => commonPageVars[`careers_${type}`] && getFilteredCareers(type).length),
    [commonPageVars],
  );

  return (
    <div>
      <div className={`${styles['careers-page']}`}>
        <HeroSection
          title={pageVars.careers.title}
          description={pageVars.careers.description}
          maxWidth="1280px"
          background="radial-gradient(ellipse 42% 48% at 22% 0%, rgba(51,92,244,0.14), transparent 68%), radial-gradient(ellipse 42% 48% at 78% 8%, rgba(138,51,214,0.08), transparent 70%), radial-gradient(ellipse 50% 40% at 50% 0%, rgba(105,216,214,0.07), transparent 72%), linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%)"
        />

        <Topics type="careers" margin="small" careerCategories={careerCategories} />

        <div className={`${styles['career-categories-wrapper']}`} id="categories-wrapper">
          {careerCategories
            .filter((category) => !type || category === type)
            .map((category) => (
              <CareerCategory
                key={category}
                title={commonPageVars[`careers_${category}`]}
                data={getFilteredCareers(category)}
              />
            ))}
        </div>
      </div>

      <Benefits
        heading={pageVars.careers.benefits_heading}
        description={pageVars.careers.benefits_description}
        benefits={benefits}
      />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default CareersPage;
